import React from 'react';
import { SvgIconProps } from '@mui/material';
import * as StrokeIcons from './stroke';
import * as FilledIcons from './filled';

export interface IconDefinition {
  /**
   * Name of the Icon, e.g. 'arrow-left'
   */
  name: string;
  /**
   * Alternative names, e.g. ['left']
   */
  altNames: string[];
  /**
   * Stroke (regular) component
   */
  component: React.FC<SvgIconProps>;
  /**
   * Filled component
   */
  componentFilled: React.FC<SvgIconProps>;
  /**
   * Marks proxy component
   */
  proxy?: boolean;
}

export const iconDefinitions: IconDefinition[] = [
  {
    name: 'atm',
    altNames: [],
    component: StrokeIcons.ATMIcon,
    componentFilled: FilledIcons.ATMFilledIcon,
  },
  {
    name: 'add',
    altNames: ['square-app-add'],
    component: StrokeIcons.AddIcon,
    componentFilled: FilledIcons.AddFilledIcon,
  },
  {
    name: 'ai-suggestion',
    altNames: [],
    component: StrokeIcons.AISuggestionIcon,
    componentFilled: FilledIcons.AISuggestionFilledIcon,
  },
  {
    name: 'air-filter',
    altNames: [],
    component: StrokeIcons.AirFilterIcon,
    componentFilled: FilledIcons.AirFilterFilledIcon,
  },
  {
    name: 'archive',
    altNames: ['archived'],
    component: StrokeIcons.ArchiveIcon,
    componentFilled: FilledIcons.ArchiveFilledIcon,
  },
  {
    name: 'arrow-bottom-left',
    altNames: ['arrow-sw'],
    component: StrokeIcons.ArrowBottomLeftIcon,
    componentFilled: FilledIcons.ArrowBottomLeftFilledIcon,
  },
  {
    name: 'arrow-bottom-right',
    altNames: ['arrow-se'],
    component: StrokeIcons.ArrowBottomRightIcon,
    componentFilled: FilledIcons.ArrowBottomRightFilledIcon,
  },
  {
    name: 'arrow-circle-bottom-left',
    altNames: ['circle-bottom-left', 'circle-arrow-sw'],
    component: StrokeIcons.ArrowCircleBottomLeftIcon,
    componentFilled: FilledIcons.ArrowCircleBottomLeftFilledIcon,
  },
  {
    name: 'arrow-circle-bottom-right',
    altNames: ['circle-bottom-right', 'circle-arrow-se'],
    component: StrokeIcons.ArrowCircleBottomRightIcon,
    componentFilled: FilledIcons.ArrowCircleBottomRightFilledIcon,
  },
  {
    name: 'arrow-circle-down',
    altNames: ['circle-arrow-down', 'circle-down'],
    component: StrokeIcons.ArrowCircleDownIcon,
    componentFilled: FilledIcons.ArrowCircleDownFilledIcon,
  },
  {
    name: 'arrow-circle-left',
    altNames: ['circle-arrow-left', 'circle-left'],
    component: StrokeIcons.ArrowCircleLeftIcon,
    componentFilled: FilledIcons.ArrowCircleLeftFilledIcon,
  },
  {
    name: 'arrow-circle-right',
    altNames: ['circle-arrow-right', 'circle-right'],
    component: StrokeIcons.ArrowCircleRightIcon,
    componentFilled: FilledIcons.ArrowCircleRightFilledIcon,
  },
  {
    name: 'arrow-circle-top-left',
    altNames: ['circle-top-left', 'circle-arrow-nw'],
    component: StrokeIcons.ArrowCircleTopLeftIcon,
    componentFilled: FilledIcons.ArrowCircleTopLeftFilledIcon,
  },
  {
    name: 'arrow-circle-top-right',
    altNames: ['circle-top-right', 'circle-arrow-ne'],
    component: StrokeIcons.ArrowCircleTopRightIcon,
    componentFilled: FilledIcons.ArrowCircleTopRightFilledIcon,
  },
  {
    name: 'arrow-circle-up',
    altNames: ['circle-up', 'circle-arrow-up'],
    component: StrokeIcons.ArrowCircleUpIcon,
    componentFilled: FilledIcons.ArrowCircleUpFilledIcon,
  },
  {
    name: 'arrow-curved-down',
    altNames: ['curved-down', 'arrow-right-down'],
    component: StrokeIcons.ArrowCurvedDownIcon,
    componentFilled: FilledIcons.ArrowCurvedDownFilledIcon,
  },
  {
    name: 'arrow-curved-down-flipped',
    altNames: ['curved-down-flipped', 'arrow-left-down'],
    component: StrokeIcons.ArrowCurvedDownFlippedIcon,
    componentFilled: FilledIcons.ArrowCurvedDownFlippedFilledIcon,
  },
  {
    name: 'arrow-curved-left',
    altNames: ['curved-left', 'arrow-down-left'],
    component: StrokeIcons.ArrowCurvedLeftIcon,
    componentFilled: FilledIcons.ArrowCurvedLeftFilledIcon,
  },
  {
    name: 'arrow-curved-left-flipped',
    altNames: ['curved-left-flipped', 'arrow-up-left'],
    component: StrokeIcons.ArrowCurvedLeftFlippedIcon,
    componentFilled: FilledIcons.ArrowCurvedLeftFlippedFilledIcon,
  },
  {
    name: 'arrow-curved-right',
    altNames: ['curved-right', 'arrow-down-right'],
    component: StrokeIcons.ArrowCurvedRightIcon,
    componentFilled: FilledIcons.ArrowCurvedRightFilledIcon,
  },
  {
    name: 'arrow-curved-right-flipped',
    altNames: ['curved-right-flipped', 'arrow-up-right'],
    component: StrokeIcons.ArrowCurvedRightFlippedIcon,
    componentFilled: FilledIcons.ArrowCurvedRightFlippedFilledIcon,
  },
  {
    name: 'arrow-curved-up',
    altNames: ['curved-up', 'arrow-right-up'],
    component: StrokeIcons.ArrowCurvedUpIcon,
    componentFilled: FilledIcons.ArrowCurvedUpFilledIcon,
  },
  {
    name: 'arrow-curved-up-flipped',
    altNames: ['curved-up-flipped', 'arrow-left-up'],
    component: StrokeIcons.ArrowCurvedUpFlippedIcon,
    componentFilled: FilledIcons.ArrowCurvedUpFlippedFilledIcon,
  },
  {
    name: 'arrow-down',
    altNames: ['arrow-bottom'],
    component: StrokeIcons.ArrowDownIcon,
    componentFilled: FilledIcons.ArrowDownFilledIcon,
  },
  {
    name: 'arrow-left',
    altNames: [],
    component: StrokeIcons.ArrowLeftIcon,
    componentFilled: FilledIcons.ArrowLeftFilledIcon,
  },
  {
    name: 'arrow-right',
    altNames: [],
    component: StrokeIcons.ArrowRightIcon,
    componentFilled: FilledIcons.ArrowRightFilledIcon,
  },
  {
    name: 'arrow-top-left',
    altNames: ['arrow-nw'],
    component: StrokeIcons.ArrowTopLeftIcon,
    componentFilled: FilledIcons.ArrowTopLeftFilledIcon,
  },
  {
    name: 'arrow-top-right',
    altNames: ['arrow-ne'],
    component: StrokeIcons.ArrowTopRightIcon,
    componentFilled: FilledIcons.ArrowTopRightFilledIcon,
  },
  {
    name: 'arrow-up',
    altNames: ['arrow-top'],
    component: StrokeIcons.ArrowUpIcon,
    componentFilled: FilledIcons.ArrowUpFilledIcon,
  },
  {
    name: 'artboard',
    altNames: ['note', 'postit'],
    component: StrokeIcons.ArtboardIcon,
    componentFilled: FilledIcons.ArtboardFilledIcon,
  },
  {
    name: 'assistance',
    altNames: ['circle-assistance'],
    component: StrokeIcons.AssistanceIcon,
    componentFilled: FilledIcons.AssistanceFilledIcon,
  },
  {
    name: 'audio-mid',
    altNames: ['sound-medium'],
    component: StrokeIcons.AudioMidIcon,
    componentFilled: FilledIcons.AudioMidFilledIcon,
  },
  {
    name: 'audio-mute',
    altNames: ['sound-off'],
    component: StrokeIcons.AudioMuteIcon,
    componentFilled: FilledIcons.AudioMuteFilledIcon,
  },
  {
    name: 'audio-off',
    altNames: ['sound'],
    component: StrokeIcons.AudioOffIcon,
    componentFilled: FilledIcons.AudioOffFilledIcon,
  },
  {
    name: 'audio-on',
    altNames: ['sound-loud'],
    component: StrokeIcons.AudioOnIcon,
    componentFilled: FilledIcons.AudioOnFilledIcon,
  },
  {
    name: 'back-to-parent',
    altNames: ['arrow-hook-left'],
    component: StrokeIcons.BackToParentIcon,
    componentFilled: FilledIcons.BackToParentFilledIcon,
  },
  {
    name: 'badge',
    altNames: [],
    component: StrokeIcons.BadgeIcon,
    componentFilled: FilledIcons.BadgeFilledIcon,
  },
  {
    name: 'balloon',
    altNames: ['message-bubble', 'speech'],
    component: StrokeIcons.BalloonIcon,
    componentFilled: FilledIcons.BalloonFilledIcon,
  },
  {
    name: 'bar',
    altNames: [],
    component: StrokeIcons.BarIcon,
    componentFilled: FilledIcons.BarFilledIcon,
  },
  {
    name: 'bar-code',
    altNames: ['barcode', 'square-ocr'],
    component: StrokeIcons.BarCodeIcon,
    componentFilled: FilledIcons.BarCodeFilledIcon,
  },
  {
    name: 'battery',
    altNames: [],
    component: StrokeIcons.BatteryIcon,
    componentFilled: FilledIcons.BatteryFilledIcon,
  },
  {
    name: 'battery-charging',
    altNames: [],
    component: StrokeIcons.BatteryChargingIcon,
    componentFilled: FilledIcons.BatteryChargingFilledIcon,
  },
  {
    name: 'battery-discharge',
    altNames: [],
    component: StrokeIcons.BatteryDischargeIcon,
    componentFilled: FilledIcons.BatteryDischargeFilledIcon,
  },
  {
    name: 'battery-empty',
    altNames: [],
    component: StrokeIcons.BatteryEmptyIcon,
    componentFilled: FilledIcons.BatteryEmptyFilledIcon,
  },
  {
    name: 'battery-error',
    altNames: [],
    component: StrokeIcons.BatteryErrorIcon,
    componentFilled: FilledIcons.BatteryErrorFilledIcon,
  },
  {
    name: 'battery-full',
    altNames: [],
    component: StrokeIcons.BatteryFullIcon,
    componentFilled: FilledIcons.BatteryFullFilledIcon,
  },
  {
    name: 'battery-high-voltage',
    altNames: [],
    component: StrokeIcons.BatteryHighVoltageIcon,
    componentFilled: FilledIcons.BatteryHighVoltageFilledIcon,
  },
  {
    name: 'battery-one-third',
    altNames: [],
    component: StrokeIcons.BatteryOneThirdIcon,
    componentFilled: FilledIcons.BatteryOneThirdFilledIcon,
  },
  {
    name: 'battery-two-thirds',
    altNames: [],
    component: StrokeIcons.BatteryTwoThirdsIcon,
    componentFilled: FilledIcons.BatteryTwoThirdsFilledIcon,
  },
  {
    name: 'battery0',
    altNames: [],
    component: StrokeIcons.Battery0Icon,
    componentFilled: FilledIcons.Battery0FilledIcon,
  },
  {
    name: 'battery10',
    altNames: [],
    component: StrokeIcons.Battery10Icon,
    componentFilled: FilledIcons.Battery10FilledIcon,
  },
  {
    name: 'battery20',
    altNames: [],
    component: StrokeIcons.Battery20Icon,
    componentFilled: FilledIcons.Battery20FilledIcon,
  },
  {
    name: 'battery30',
    altNames: [],
    component: StrokeIcons.Battery30Icon,
    componentFilled: FilledIcons.Battery30FilledIcon,
  },
  {
    name: 'battery40',
    altNames: [],
    component: StrokeIcons.Battery40Icon,
    componentFilled: FilledIcons.Battery40FilledIcon,
  },
  {
    name: 'battery50',
    altNames: [],
    component: StrokeIcons.Battery50Icon,
    componentFilled: FilledIcons.Battery50FilledIcon,
  },
  {
    name: 'battery60',
    altNames: [],
    component: StrokeIcons.Battery60Icon,
    componentFilled: FilledIcons.Battery60FilledIcon,
  },
  {
    name: 'battery70',
    altNames: [],
    component: StrokeIcons.Battery70Icon,
    componentFilled: FilledIcons.Battery70FilledIcon,
  },
  {
    name: 'battery80',
    altNames: [],
    component: StrokeIcons.Battery80Icon,
    componentFilled: FilledIcons.Battery80FilledIcon,
  },
  {
    name: 'battery90',
    altNames: [],
    component: StrokeIcons.Battery90Icon,
    componentFilled: FilledIcons.Battery90FilledIcon,
  },
  {
    name: 'battery100',
    altNames: [],
    component: StrokeIcons.Battery100Icon,
    componentFilled: FilledIcons.Battery100FilledIcon,
  },
  {
    name: 'bell',
    altNames: [],
    component: StrokeIcons.BellIcon,
    componentFilled: FilledIcons.BellFilledIcon,
  },
  {
    name: 'bicycle',
    altNames: [],
    component: StrokeIcons.BicycleIcon,
    componentFilled: FilledIcons.BicycleFilledIcon,
  },
  {
    name: 'bolt-discharge',
    altNames: [],
    component: StrokeIcons.BoltDischargeIcon,
    componentFilled: FilledIcons.BoltDischargeFilledIcon,
  },
  {
    name: 'bolt',
    altNames: ['thunder'],
    component: StrokeIcons.BoltIcon,
    componentFilled: FilledIcons.BoltFilledIcon,
  },
  {
    name: 'bolt-motion',
    altNames: [],
    component: StrokeIcons.BoltMotionIcon,
    componentFilled: FilledIcons.BoltMotionFilledIcon,
  },
  {
    name: 'bolt-off',
    altNames: [],
    component: StrokeIcons.BoltOffIcon,
    componentFilled: FilledIcons.BoltOffFilledIcon,
  },
  {
    name: 'bonnet-closed',
    altNames: [],
    component: StrokeIcons.BonnetClosedIcon,
    componentFilled: FilledIcons.BonnetClosedFilledIcon,
  },
  {
    name: 'bonnet-open',
    altNames: [],
    component: StrokeIcons.BonnetOpenIcon,
    componentFilled: FilledIcons.BonnetOpenFilledIcon,
  },
  {
    name: 'bookmark',
    altNames: ['rectangle-vertical-bookmark'],
    component: StrokeIcons.BookmarkIcon,
    componentFilled: FilledIcons.BookmarkFilledIcon,
  },
  {
    name: 'boot-closed',
    altNames: [],
    component: StrokeIcons.BootClosedIcon,
    componentFilled: FilledIcons.BootClosedFilledIcon,
  },
  {
    name: 'boot-open',
    altNames: [],
    component: StrokeIcons.BootOpenIcon,
    componentFilled: FilledIcons.BootOpenFilledIcon,
  },
  {
    name: 'box',
    altNames: [],
    component: StrokeIcons.BoxIcon,
    componentFilled: FilledIcons.BoxFilledIcon,
  },
  {
    name: 'brake-fluid',
    altNames: [],
    component: StrokeIcons.BrakeFluidIcon,
    componentFilled: FilledIcons.BrakeFluidFilledIcon,
  },
  {
    name: 'brakes',
    altNames: ['breaks', 'circle-breaks'],
    component: StrokeIcons.BrakesIcon,
    componentFilled: FilledIcons.BrakesFilledIcon,
  },
  {
    name: 'brightness',
    altNames: ['light'],
    component: StrokeIcons.BrightnessIcon,
    componentFilled: FilledIcons.BrightnessFilledIcon,
  },
  {
    name: 'building',
    altNames: [],
    component: StrokeIcons.BuildingIcon,
    componentFilled: FilledIcons.BuildingFilledIcon,
  },
  {
    name: 'calculator',
    altNames: [],
    component: StrokeIcons.CalculatorIcon,
    componentFilled: FilledIcons.CalculatorFilledIcon,
  },
  {
    name: 'calendar-calendar',
    altNames: [],
    component: StrokeIcons.CalendarCalendarIcon,
    componentFilled: FilledIcons.CalendarCalendarFilledIcon,
  },
  {
    name: 'calendar-check',
    altNames: ['scheduled-task'],
    component: StrokeIcons.CalendarCheckIcon,
    componentFilled: FilledIcons.CalendarCheckFilledIcon,
  },
  {
    name: 'calendar-point',
    altNames: ['event'],
    component: StrokeIcons.CalendarPointIcon,
    componentFilled: FilledIcons.CalendarPointFilledIcon,
  },
  {
    name: 'camera',
    altNames: [],
    component: StrokeIcons.CameraIcon,
    componentFilled: FilledIcons.CameraFilledIcon,
  },
  {
    name: 'camping',
    altNames: [],
    component: StrokeIcons.CampingIcon,
    componentFilled: FilledIcons.CampingFilledIcon,
  },
  {
    name: 'car',
    altNames: [],
    component: StrokeIcons.CarIcon,
    componentFilled: FilledIcons.CarFilledIcon,
  },
  {
    name: 'car-accident',
    altNames: [],
    component: StrokeIcons.CarAccidentIcon,
    componentFilled: FilledIcons.CarAccidentFilledIcon,
  },
  {
    name: 'car-back',
    altNames: [],
    component: StrokeIcons.CarBackIcon,
    componentFilled: FilledIcons.CarBackFilledIcon,
  },
  {
    name: 'car-comparison',
    altNames: [],
    component: StrokeIcons.CarComparisonIcon,
    componentFilled: FilledIcons.CarComparisonFilledIcon,
  },
  {
    name: 'car-door',
    altNames: [],
    component: StrokeIcons.CarDoorIcon,
    componentFilled: FilledIcons.CarDoorFilledIcon,
  },
  {
    name: 'car-hand',
    altNames: [],
    component: StrokeIcons.CarHandIcon,
    componentFilled: FilledIcons.CarHandFilledIcon,
  },
  {
    name: 'car-info',
    altNames: [],
    component: StrokeIcons.CarInfoIcon,
    componentFilled: FilledIcons.CarInfoFilledIcon,
  },
  {
    name: 'car-magnifier',
    altNames: [],
    component: StrokeIcons.CarMagnifierIcon,
    componentFilled: FilledIcons.CarMagnifierFilledIcon,
  },
  {
    name: 'car-seat',
    altNames: [],
    component: StrokeIcons.CarSeatIcon,
    componentFilled: FilledIcons.CarSeatFilledIcon,
  },
  {
    name: 'car-send',
    altNames: [],
    component: StrokeIcons.CarSendIcon,
    componentFilled: FilledIcons.CarSendFilledIcon,
  },
  {
    name: 'car-side',
    altNames: [],
    component: StrokeIcons.CarSideIcon,
    componentFilled: FilledIcons.CarSideFilledIcon,
  },
  {
    name: 'car-star',
    altNames: [],
    component: StrokeIcons.CarStarIcon,
    componentFilled: FilledIcons.CarStarFilledIcon,
  },
  {
    name: 'car-status',
    altNames: [],
    component: StrokeIcons.CarStatusIcon,
    componentFilled: FilledIcons.CarStatusFilledIcon,
  },
  {
    name: 'car-technical-info',
    altNames: [],
    component: StrokeIcons.CarTechnicalInfoIcon,
    componentFilled: FilledIcons.CarTechnicalInfoFilledIcon,
  },
  {
    name: 'card',
    altNames: ['credit-card'],
    component: StrokeIcons.CardIcon,
    componentFilled: FilledIcons.CardFilledIcon,
  },
  {
    name: 'care-mobility',
    altNames: [],
    component: StrokeIcons.CareMobilityIcon,
    componentFilled: FilledIcons.CareMobilityFilledIcon,
  },
  {
    name: 'change-order',
    altNames: ['arrow-exchange'],
    component: StrokeIcons.ChangeOrderIcon,
    componentFilled: FilledIcons.ChangeOrderFilledIcon,
  },
  {
    name: 'chat',
    altNames: [],
    component: StrokeIcons.ChatIcon,
    componentFilled: FilledIcons.ChatFilledIcon,
  },
  {
    name: 'check',
    altNames: [],
    component: StrokeIcons.CheckIcon,
    componentFilled: FilledIcons.CheckFilledIcon,
  },
  {
    name: 'chevron-circle-down',
    altNames: ['circle-chevron-down', 'circle-arrowhead-down'],
    component: StrokeIcons.ChevronCircleDownIcon,
    componentFilled: FilledIcons.ChevronCircleDownFilledIcon,
  },
  {
    name: 'chevron-circle-left',
    altNames: ['circle-chevron-left', 'circle-arrowhead-left'],
    component: StrokeIcons.ChevronCircleLeftIcon,
    componentFilled: FilledIcons.ChevronCircleLeftFilledIcon,
  },
  {
    name: 'chevron-circle-right',
    altNames: ['circle-chevron-right', 'circle-arrowhead-right'],
    component: StrokeIcons.ChevronCircleRightIcon,
    componentFilled: FilledIcons.ChevronCircleRightFilledIcon,
  },
  {
    name: 'chevron-circle-up',
    altNames: ['circle-chevron-up', 'circle-arrowhead-up'],
    component: StrokeIcons.ChevronCircleUpIcon,
    componentFilled: FilledIcons.ChevronCircleUpFilledIcon,
  },
  {
    name: 'chevron-double-down',
    altNames: ['double-chevron-down'],
    component: StrokeIcons.ChevronDoubleDownIcon,
    componentFilled: FilledIcons.ChevronDoubleDownFilledIcon,
  },
  {
    name: 'chevron-double-left',
    altNames: ['double-chevron-left'],
    component: StrokeIcons.ChevronDoubleLeftIcon,
    componentFilled: FilledIcons.ChevronDoubleLeftFilledIcon,
  },
  {
    name: 'chevron-double-right',
    altNames: ['double-chevron-right'],
    component: StrokeIcons.ChevronDoubleRightIcon,
    componentFilled: FilledIcons.ChevronDoubleRightFilledIcon,
  },
  {
    name: 'chevron-double-up',
    altNames: ['double-chevron-up'],
    component: StrokeIcons.ChevronDoubleUpIcon,
    componentFilled: FilledIcons.ChevronDoubleUpFilledIcon,
  },
  {
    name: 'chevron-down',
    altNames: ['chevron-bottom'],
    component: StrokeIcons.ChevronDownIcon,
    componentFilled: FilledIcons.ChevronDownFilledIcon,
  },
  {
    name: 'chevron-left',
    altNames: [],
    component: StrokeIcons.ChevronLeftIcon,
    componentFilled: FilledIcons.ChevronLeftFilledIcon,
  },
  {
    name: 'chevron-next',
    altNames: [],
    component: StrokeIcons.ChevronNextIcon,
    componentFilled: FilledIcons.ChevronNextFilledIcon,
  },
  {
    name: 'chevron-previous',
    altNames: [],
    component: StrokeIcons.ChevronPreviousIcon,
    componentFilled: FilledIcons.ChevronPreviousFilledIcon,
  },
  {
    name: 'chevron-right',
    altNames: [],
    component: StrokeIcons.ChevronRightIcon,
    componentFilled: FilledIcons.ChevronRightFilledIcon,
  },
  {
    name: 'chevron-up',
    altNames: ['chevron-top'],
    component: StrokeIcons.ChevronUpIcon,
    componentFilled: FilledIcons.ChevronUpFilledIcon,
  },
  {
    name: 'circle-bluetooth',
    altNames: ['circle-bluetooth-white'],
    component: StrokeIcons.CircleBluetoothIcon,
    componentFilled: FilledIcons.CircleBluetoothFilledIcon,
  },
  {
    name: 'circle-check',
    altNames: [],
    component: StrokeIcons.CircleCheckIcon,
    componentFilled: FilledIcons.CircleCheckFilledIcon,
  },
  {
    name: 'circle-close',
    altNames: ['circle-multiply'],
    component: StrokeIcons.CircleCloseIcon,
    componentFilled: FilledIcons.CircleCloseFilledIcon,
  },
  {
    name: 'circle-download',
    altNames: [],
    component: StrokeIcons.CircleDownloadIcon,
    componentFilled: FilledIcons.CircleDownloadFilledIcon,
  },
  {
    name: 'circle-exclamation',
    altNames: [],
    component: StrokeIcons.CircleExclamationIcon,
    componentFilled: FilledIcons.CircleExclamationFilledIcon,
  },
  {
    name: 'circle-information',
    altNames: ['circle-info'],
    component: StrokeIcons.CircleInformationIcon,
    componentFilled: FilledIcons.CircleInformationFilledIcon,
  },
  {
    name: 'circle-minus',
    altNames: [],
    component: StrokeIcons.CircleMinusIcon,
    componentFilled: FilledIcons.CircleMinusFilledIcon,
  },
  {
    name: 'circle-plus',
    altNames: [],
    component: StrokeIcons.CirclePlusIcon,
    componentFilled: FilledIcons.CirclePlusFilledIcon,
  },
  {
    name: 'circle-question',
    altNames: [],
    component: StrokeIcons.CircleQuestionIcon,
    componentFilled: FilledIcons.CircleQuestionFilledIcon,
  },
  {
    name: 'circle-slash',
    altNames: ['circle-no'],
    component: StrokeIcons.CircleSlashIcon,
    componentFilled: FilledIcons.CircleSlashFilledIcon,
  },
  {
    name: 'circle-upload',
    altNames: [],
    component: StrokeIcons.CircleUploadIcon,
    componentFilled: FilledIcons.CircleUploadFilledIcon,
  },
  {
    name: 'clip',
    altNames: [],
    component: StrokeIcons.ClipIcon,
    componentFilled: FilledIcons.ClipFilledIcon,
  },
  {
    name: 'clock',
    altNames: [],
    component: StrokeIcons.ClockIcon,
    componentFilled: FilledIcons.ClockFilledIcon,
  },
  {
    name: 'close',
    altNames: ['ballotx'],
    component: StrokeIcons.CloseIcon,
    componentFilled: FilledIcons.CloseFilledIcon,
  },
  {
    name: 'closedcaptions',
    altNames: [],
    component: StrokeIcons.ClosedcaptionsIcon,
    componentFilled: FilledIcons.ClosedcaptionsFilledIcon,
  },
  {
    name: 'cloud-co2',
    altNames: [],
    component: StrokeIcons.CloudCO2Icon,
    componentFilled: FilledIcons.CloudCO2FilledIcon,
  },
  {
    name: 'cloud-download',
    altNames: [],
    component: StrokeIcons.CloudDownloadIcon,
    componentFilled: FilledIcons.CloudDownloadFilledIcon,
  },
  {
    name: 'cloud-upload',
    altNames: [],
    component: StrokeIcons.CloudUploadIcon,
    componentFilled: FilledIcons.CloudUploadFilledIcon,
  },
  {
    name: 'colours',
    altNames: ['colors'],
    component: StrokeIcons.ColoursIcon,
    componentFilled: FilledIcons.ColoursFilledIcon,
  },
  {
    name: 'comfort',
    altNames: [],
    component: StrokeIcons.ComfortIcon,
    componentFilled: FilledIcons.ComfortFilledIcon,
  },
  {
    name: 'contrast',
    altNames: ['circle-contrast'],
    component: StrokeIcons.ContrastIcon,
    componentFilled: FilledIcons.ContrastFilledIcon,
  },
  {
    name: 'controls-forward',
    altNames: [],
    component: StrokeIcons.ControlsForwardIcon,
    componentFilled: FilledIcons.ControlsForwardFilledIcon,
  },
  {
    name: 'controls-pause',
    altNames: ['pause'],
    component: StrokeIcons.ControlsPauseIcon,
    componentFilled: FilledIcons.ControlsPauseFilledIcon,
  },
  {
    name: 'controls-play',
    altNames: ['play', 'play-right'],
    component: StrokeIcons.ControlsPlayIcon,
    componentFilled: FilledIcons.ControlsPlayFilledIcon,
  },
  {
    name: 'controls-record',
    altNames: ['record'],
    component: StrokeIcons.ControlsRecordIcon,
    componentFilled: FilledIcons.ControlsRecordFilledIcon,
  },
  {
    name: 'controls-reverse',
    altNames: ['reverse', 'play-left'],
    component: StrokeIcons.ControlsReverseIcon,
    componentFilled: FilledIcons.ControlsReverseFilledIcon,
  },
  {
    name: 'controls-rewind',
    altNames: [],
    component: StrokeIcons.ControlsRewindIcon,
    componentFilled: FilledIcons.ControlsRewindFilledIcon,
  },
  {
    name: 'controls-skip-next',
    altNames: ['next', 'play-next'],
    component: StrokeIcons.ControlsSkipNextIcon,
    componentFilled: FilledIcons.ControlsSkipNextFilledIcon,
  },
  {
    name: 'controls-skip-previous',
    altNames: ['previous', 'play-previous'],
    component: StrokeIcons.ControlsSkipPreviousIcon,
    componentFilled: FilledIcons.ControlsSkipPreviousFilledIcon,
  },
  {
    name: 'controls-stop',
    altNames: [],
    component: StrokeIcons.ControlsStopIcon,
    componentFilled: FilledIcons.ControlsStopFilledIcon,
  },
  {
    name: 'cookie',
    altNames: [],
    component: StrokeIcons.CookieIcon,
    componentFilled: FilledIcons.CookieFilledIcon,
  },
  {
    name: 'copy',
    altNames: [],
    component: StrokeIcons.CopyIcon,
    componentFilled: FilledIcons.CopyFilledIcon,
  },
  {
    name: 'culture',
    altNames: [],
    component: StrokeIcons.CultureIcon,
    componentFilled: FilledIcons.CultureFilledIcon,
  },
  {
    name: 'cut',
    altNames: [],
    component: StrokeIcons.CutIcon,
    componentFilled: FilledIcons.CutFilledIcon,
  },
  {
    name: 'dealer',
    altNames: [],
    component: StrokeIcons.DealerIcon,
    componentFilled: FilledIcons.DealerFilledIcon,
  },
  {
    name: 'dealership-service',
    altNames: [],
    component: StrokeIcons.DealershipServiceIcon,
    componentFilled: FilledIcons.DealershipServiceFilledIcon,
  },
  {
    name: 'delivery',
    altNames: [],
    component: StrokeIcons.DeliveryIcon,
    componentFilled: FilledIcons.DeliveryFilledIcon,
  },
  {
    name: 'details',
    altNames: [],
    component: StrokeIcons.DetailsIcon,
    componentFilled: FilledIcons.DetailsFilledIcon,
  },
  {
    name: 'device-smartphone',
    altNames: [],
    component: StrokeIcons.DeviceSmartphoneIcon,
    componentFilled: FilledIcons.DeviceSmartphoneFilledIcon,
  },
  {
    name: 'doors-closed',
    altNames: [],
    component: StrokeIcons.DoorsClosedIcon,
    componentFilled: FilledIcons.DoorsClosedFilledIcon,
  },
  {
    name: 'doors-open',
    altNames: [],
    component: StrokeIcons.DoorsOpenIcon,
    componentFilled: FilledIcons.DoorsOpenFilledIcon,
  },
  {
    name: 'download',
    altNames: ['arrow-download'],
    component: StrokeIcons.DownloadIcon,
    componentFilled: FilledIcons.DownloadFilledIcon,
  },
  {
    name: 'draghandle',
    altNames: ['drag-handle'],
    component: StrokeIcons.DraghandleIcon,
    componentFilled: FilledIcons.DraghandleFilledIcon,
  },
  {
    name: 'edit',
    altNames: [],
    component: StrokeIcons.EditIcon,
    componentFilled: FilledIcons.EditFilledIcon,
  },
  {
    name: 'electric-charger',
    altNames: ['charger', 'fuel-electric'],
    component: StrokeIcons.ElectricChargerIcon,
    componentFilled: FilledIcons.ElectricChargerFilledIcon,
  },
  {
    name: 'electric-charger-off',
    altNames: [],
    component: StrokeIcons.ElectricChargerOffIcon,
    componentFilled: FilledIcons.ElectricChargerOffFilledIcon,
  },
  {
    name: 'emptystate',
    altNames: [],
    component: StrokeIcons.EmptystateIcon,
    componentFilled: FilledIcons.EmptystateFilledIcon,
  },
  {
    name: 'engine',
    altNames: [],
    component: StrokeIcons.EngineIcon,
    componentFilled: FilledIcons.EngineFilledIcon,
  },
  {
    name: 'engine-oil',
    altNames: [],
    component: StrokeIcons.EngineOilIcon,
    componentFilled: FilledIcons.EngineOilFilledIcon,
  },
  {
    name: 'entertainment',
    altNames: [],
    component: StrokeIcons.EntertainmentIcon,
    componentFilled: FilledIcons.EntertainmentFilledIcon,
  },
  {
    name: 'equalsign',
    altNames: [],
    component: StrokeIcons.EqualsignIcon,
    componentFilled: FilledIcons.EqualsignFilledIcon,
  },
  {
    name: 'export',
    altNames: ['arrow-export'],
    component: StrokeIcons.ExportIcon,
    componentFilled: FilledIcons.ExportFilledIcon,
  },
  {
    name: 'external-link',
    altNames: ['square-expand'],
    component: StrokeIcons.ExternalLinkIcon,
    componentFilled: FilledIcons.ExternalLinkFilledIcon,
  },
  {
    name: 'facebook',
    altNames: [],
    component: StrokeIcons.FacebookIcon,
    componentFilled: FilledIcons.FacebookFilledIcon,
  },
  {
    name: 'factory',
    altNames: [],
    component: StrokeIcons.FactoryIcon,
    componentFilled: FilledIcons.FactoryFilledIcon,
  },
  {
    name: 'fan',
    altNames: ['air'],
    component: StrokeIcons.FanIcon,
    componentFilled: FilledIcons.FanFilledIcon,
  },
  {
    name: 'feedback',
    altNames: [],
    component: StrokeIcons.FeedbackIcon,
    componentFilled: FilledIcons.FeedbackFilledIcon,
  },
  {
    name: 'file',
    altNames: ['document'],
    component: StrokeIcons.FileIcon,
    componentFilled: FilledIcons.FileFilledIcon,
  },
  {
    name: 'file-missing',
    altNames: ['missing', 'document-missing'],
    component: StrokeIcons.FileMissingIcon,
    componentFilled: FilledIcons.FileMissingFilledIcon,
  },
  {
    name: 'file-new',
    altNames: ['new', 'document-new'],
    component: StrokeIcons.FileNewIcon,
    componentFilled: FilledIcons.FileNewFilledIcon,
  },
  {
    name: 'filter',
    altNames: [],
    component: StrokeIcons.FilterIcon,
    componentFilled: FilledIcons.FilterFilledIcon,
  },
  {
    name: 'filters',
    altNames: [],
    component: StrokeIcons.FiltersIcon,
    componentFilled: FilledIcons.FiltersFilledIcon,
  },
  {
    name: 'finger-print',
    altNames: ['id'],
    component: StrokeIcons.FingerPrintIcon,
    componentFilled: FilledIcons.FingerPrintFilledIcon,
  },
  {
    name: 'first-aid',
    altNames: ['health-alt'],
    component: StrokeIcons.FirstAidIcon,
    componentFilled: FilledIcons.FirstAidFilledIcon,
  },
  {
    name: 'flash',
    altNames: [],
    component: StrokeIcons.FlashIcon,
    componentFilled: FilledIcons.FlashFilledIcon,
  },
  {
    name: 'folder',
    altNames: [],
    component: StrokeIcons.FolderIcon,
    componentFilled: FilledIcons.FolderFilledIcon,
  },
  {
    name: 'folder-share',
    altNames: ['folder-send'],
    component: StrokeIcons.FolderShareIcon,
    componentFilled: FilledIcons.FolderShareFilledIcon,
  },
  {
    name: 'food',
    altNames: [],
    component: StrokeIcons.FoodIcon,
    componentFilled: FilledIcons.FoodFilledIcon,
  },
  {
    name: 'fourwheeldrive',
    altNames: [],
    component: StrokeIcons.FourwheeldriveIcon,
    componentFilled: FilledIcons.FourwheeldriveFilledIcon,
  },
  {
    name: 'frontaxle',
    altNames: [],
    component: StrokeIcons.FrontaxleIcon,
    componentFilled: FilledIcons.FrontaxleFilledIcon,
  },
  {
    name: 'fuel-savings',
    altNames: [],
    component: StrokeIcons.FuelSavingsIcon,
    componentFilled: FilledIcons.FuelSavingsFilledIcon,
  },
  {
    name: 'fullscreen-enter',
    altNames: [],
    component: StrokeIcons.FullscreenEnterIcon,
    componentFilled: FilledIcons.FullscreenEnterFilledIcon,
  },
  {
    name: 'fullscreen-exit',
    altNames: [],
    component: StrokeIcons.FullscreenExitIcon,
    componentFilled: FilledIcons.FullscreenExitFilledIcon,
  },
  {
    name: 'garage',
    altNames: [],
    component: StrokeIcons.GarageIcon,
    componentFilled: FilledIcons.GarageFilledIcon,
  },
  {
    name: 'gauge',
    altNames: [],
    component: StrokeIcons.GaugeIcon,
    componentFilled: FilledIcons.GaugeFilledIcon,
  },
  {
    name: 'globe',
    altNames: [],
    component: StrokeIcons.GlobeIcon,
    componentFilled: FilledIcons.GlobeFilledIcon,
  },
  {
    name: 'group',
    altNames: [],
    component: StrokeIcons.GroupIcon,
    componentFilled: FilledIcons.GroupFilledIcon,
  },
  {
    name: 'handkey',
    altNames: [],
    component: StrokeIcons.HandkeyIcon,
    componentFilled: FilledIcons.HandkeyFilledIcon,
  },
  {
    name: 'health-scan',
    altNames: ['health', 'square-scan-health'],
    component: StrokeIcons.HealthScanIcon,
    componentFilled: FilledIcons.HealthScanFilledIcon,
  },
  {
    name: 'heart',
    altNames: [],
    component: StrokeIcons.HeartIcon,
    componentFilled: FilledIcons.HeartFilledIcon,
  },
  {
    name: 'hide',
    altNames: ['preview-off'],
    component: StrokeIcons.HideIcon,
    componentFilled: FilledIcons.HideFilledIcon,
  },
  {
    name: 'history',
    altNames: [],
    component: StrokeIcons.HistoryIcon,
    componentFilled: FilledIcons.HistoryFilledIcon,
  },
  {
    name: 'home',
    altNames: [],
    component: StrokeIcons.HomeIcon,
    componentFilled: FilledIcons.HomeFilledIcon,
  },
  {
    name: 'honk',
    altNames: [],
    component: StrokeIcons.HonkIcon,
    componentFilled: FilledIcons.HonkFilledIcon,
  },
  {
    name: 'hotel',
    altNames: [],
    component: StrokeIcons.HotelIcon,
    componentFilled: FilledIcons.HotelFilledIcon,
  },
  {
    name: 'hybrid',
    altNames: [],
    component: StrokeIcons.HybridIcon,
    componentFilled: FilledIcons.HybridFilledIcon,
  },
  {
    name: 'id-card',
    altNames: ['business-card'],
    component: StrokeIcons.IDCardIcon,
    componentFilled: FilledIcons.IDCardFilledIcon,
  },
  {
    name: 'import',
    altNames: ['arrow-import'],
    component: StrokeIcons.ImportIcon,
    componentFilled: FilledIcons.ImportFilledIcon,
  },
  {
    name: 'inbox',
    altNames: [],
    component: StrokeIcons.InboxIcon,
    componentFilled: FilledIcons.InboxFilledIcon,
  },
  {
    name: 'instagram',
    altNames: [],
    component: StrokeIcons.InstagramIcon,
    componentFilled: FilledIcons.InstagramFilledIcon,
  },
  {
    name: 'lights',
    altNames: ['headlights'],
    component: StrokeIcons.LightsIcon,
    componentFilled: FilledIcons.LightsFilledIcon,
  },
  {
    name: 'lights-off',
    altNames: [],
    component: StrokeIcons.LightsOffIcon,
    componentFilled: FilledIcons.LightsOffFilledIcon,
  },
  {
    name: 'linkedin',
    altNames: [],
    component: StrokeIcons.LinkedInIcon,
    componentFilled: FilledIcons.LinkedInFilledIcon,
  },
  {
    name: 'list',
    altNames: [],
    component: StrokeIcons.ListIcon,
    componentFilled: FilledIcons.ListFilledIcon,
  },
  {
    name: 'lock-closed',
    altNames: ['locked', 'lock'],
    component: StrokeIcons.LockClosedIcon,
    componentFilled: FilledIcons.LockClosedFilledIcon,
  },
  {
    name: 'lock-opened',
    altNames: ['unlocked', 'lock-open'],
    component: StrokeIcons.LockOpenedIcon,
    componentFilled: FilledIcons.LockOpenedFilledIcon,
  },
  {
    name: 'lock-opened-alt',
    altNames: [],
    component: StrokeIcons.LockOpenedAltIcon,
    componentFilled: FilledIcons.LockOpenedAltFilledIcon,
  },
  {
    name: 'locked-steering-wheel',
    altNames: ['steering-locked', 'circle-steering-off'],
    component: StrokeIcons.LockedSteeringWheelIcon,
    componentFilled: FilledIcons.LockedSteeringWheelFilledIcon,
  },
  {
    name: 'login',
    altNames: [],
    component: StrokeIcons.LoginIcon,
    componentFilled: FilledIcons.LoginFilledIcon,
  },
  {
    name: 'logout',
    altNames: [],
    component: StrokeIcons.LogoutIcon,
    componentFilled: FilledIcons.LogoutFilledIcon,
  },
  {
    name: 'maintenance',
    altNames: ['service'],
    component: StrokeIcons.MaintenanceIcon,
    componentFilled: FilledIcons.MaintenanceFilledIcon,
  },
  {
    name: 'manual',
    altNames: [],
    component: StrokeIcons.ManualIcon,
    componentFilled: FilledIcons.ManualFilledIcon,
  },
  {
    name: 'map',
    altNames: [],
    component: StrokeIcons.MapIcon,
    componentFilled: FilledIcons.MapFilledIcon,
  },
  {
    name: 'map-center',
    altNames: ['locate', 'coordinates'],
    component: StrokeIcons.MapCenterIcon,
    componentFilled: FilledIcons.MapCenterFilledIcon,
  },
  {
    name: 'map-compass',
    altNames: [],
    component: StrokeIcons.MapCompassIcon,
    componentFilled: FilledIcons.MapCompassFilledIcon,
  },
  {
    name: 'map-flag',
    altNames: [],
    component: StrokeIcons.MapFlagIcon,
    componentFilled: FilledIcons.MapFlagFilledIcon,
  },
  {
    name: 'map-location',
    altNames: [],
    component: StrokeIcons.MapLocationIcon,
    componentFilled: FilledIcons.MapLocationFilledIcon,
  },
  {
    name: 'map-marker',
    altNames: ['marker', 'position'],
    component: StrokeIcons.MapMarkerIcon,
    componentFilled: FilledIcons.MapMarkerFilledIcon,
  },
  {
    name: 'map-marker-lbo',
    altNames: [],
    component: StrokeIcons.MapMarkerLBOIcon,
    componentFilled: FilledIcons.MapMarkerLBOFilledIcon,
  },
  {
    name: 'map-pin',
    altNames: [],
    component: StrokeIcons.MapPinIcon,
    componentFilled: FilledIcons.MapPinFilledIcon,
  },
  {
    name: 'map-view',
    altNames: [],
    component: StrokeIcons.MapViewIcon,
    componentFilled: FilledIcons.MapViewFilledIcon,
  },
  {
    name: 'menu',
    altNames: ['hamburger'],
    component: StrokeIcons.MenuIcon,
    componentFilled: FilledIcons.MenuFilledIcon,
  },
  {
    name: 'menu-waffle',
    altNames: ['square-grid'],
    component: StrokeIcons.MenuWaffleIcon,
    componentFilled: FilledIcons.MenuWaffleFilledIcon,
  },
  {
    name: 'message',
    altNames: ['mail'],
    component: StrokeIcons.MessageIcon,
    componentFilled: FilledIcons.MessageFilledIcon,
  },
  {
    name: 'microphone',
    altNames: [],
    component: StrokeIcons.MicrophoneIcon,
    componentFilled: FilledIcons.MicrophoneFilledIcon,
  },
  {
    name: 'minus',
    altNames: [],
    component: StrokeIcons.MinusIcon,
    componentFilled: FilledIcons.MinusFilledIcon,
  },
  {
    name: 'more-horizontal',
    altNames: ['horizontal'],
    component: StrokeIcons.MoreHorizontalIcon,
    componentFilled: FilledIcons.MoreHorizontalFilledIcon,
  },
  {
    name: 'more-vertical',
    altNames: ['vertical'],
    component: StrokeIcons.MoreVerticalIcon,
    componentFilled: FilledIcons.MoreVerticalFilledIcon,
  },
  {
    name: 'motion',
    altNames: [],
    component: StrokeIcons.MotionIcon,
    componentFilled: FilledIcons.MotionFilledIcon,
  },
  {
    name: 'musical-note',
    altNames: ['audio-note', 'music'],
    component: StrokeIcons.MusicalNoteIcon,
    componentFilled: FilledIcons.MusicalNoteFilledIcon,
  },
  {
    name: 'mute',
    altNames: ['microphone-off'],
    component: StrokeIcons.MuteIcon,
    componentFilled: FilledIcons.MuteFilledIcon,
  },
  {
    name: 'news',
    altNames: ['news-post'],
    component: StrokeIcons.NewsIcon,
    componentFilled: FilledIcons.NewsFilledIcon,
  },
  {
    name: 'newspaper',
    altNames: [],
    component: StrokeIcons.NewspaperIcon,
    componentFilled: FilledIcons.NewspaperFilledIcon,
  },
  {
    name: 'oil',
    altNames: [],
    component: StrokeIcons.OilIcon,
    componentFilled: FilledIcons.OilFilledIcon,
  },
  {
    name: 'parking',
    altNames: [],
    component: StrokeIcons.ParkingIcon,
    componentFilled: FilledIcons.ParkingFilledIcon,
  },
  {
    name: 'paste',
    altNames: [],
    component: StrokeIcons.PasteIcon,
    componentFilled: FilledIcons.PasteFilledIcon,
  },
  {
    name: 'percentage',
    altNames: [],
    component: StrokeIcons.PercentageIcon,
    componentFilled: FilledIcons.PercentageFilledIcon,
  },
  {
    name: 'pet',
    altNames: [],
    component: StrokeIcons.PetIcon,
    componentFilled: FilledIcons.PetFilledIcon,
  },
  {
    name: 'phone',
    altNames: ['call'],
    component: StrokeIcons.PhoneIcon,
    componentFilled: FilledIcons.PhoneFilledIcon,
  },
  {
    name: 'picture',
    altNames: [],
    component: StrokeIcons.PictureIcon,
    componentFilled: FilledIcons.PictureFilledIcon,
  },
  {
    name: 'piggybank',
    altNames: [],
    component: StrokeIcons.PiggybankIcon,
    componentFilled: FilledIcons.PiggybankFilledIcon,
  },
  {
    name: 'plug',
    altNames: [],
    component: StrokeIcons.PlugIcon,
    componentFilled: FilledIcons.PlugFilledIcon,
  },
  {
    name: 'plug-ccs-type1',
    altNames: [],
    component: StrokeIcons.PlugCCSType1Icon,
    componentFilled: FilledIcons.PlugCCSType1FilledIcon,
  },
  {
    name: 'plug-ccs-type2',
    altNames: [],
    component: StrokeIcons.PlugCCSType2Icon,
    componentFilled: FilledIcons.PlugCCSType2FilledIcon,
  },
  {
    name: 'plug-chademo',
    altNames: [],
    component: StrokeIcons.PlugCHAdeMOIcon,
    componentFilled: FilledIcons.PlugCHAdeMOFilledIcon,
  },
  {
    name: 'plug-type1',
    altNames: [],
    component: StrokeIcons.PlugType1Icon,
    componentFilled: FilledIcons.PlugType1FilledIcon,
  },
  {
    name: 'plug-type2',
    altNames: [],
    component: StrokeIcons.PlugType2Icon,
    componentFilled: FilledIcons.PlugType2FilledIcon,
  },
  {
    name: 'plus',
    altNames: [],
    component: StrokeIcons.PlusIcon,
    componentFilled: FilledIcons.PlusFilledIcon,
  },
  {
    name: 'premium-l',
    altNames: [],
    component: StrokeIcons.PremiumLIcon,
    componentFilled: FilledIcons.PremiumLFilledIcon,
  },
  {
    name: 'premium-m',
    altNames: [],
    component: StrokeIcons.PremiumMIcon,
    componentFilled: FilledIcons.PremiumMFilledIcon,
  },
  {
    name: 'premium-s',
    altNames: [],
    component: StrokeIcons.PremiumSIcon,
    componentFilled: FilledIcons.PremiumSFilledIcon,
  },
  {
    name: 'price-tag',
    altNames: ['tag'],
    component: StrokeIcons.PriceTagIcon,
    componentFilled: FilledIcons.PriceTagFilledIcon,
  },
  {
    name: 'print',
    altNames: [],
    component: StrokeIcons.PrintIcon,
    componentFilled: FilledIcons.PrintFilledIcon,
  },
  {
    name: 'production',
    altNames: [],
    component: StrokeIcons.ProductionIcon,
    componentFilled: FilledIcons.ProductionFilledIcon,
  },
  {
    name: 'publicplace',
    altNames: [],
    component: StrokeIcons.PublicplaceIcon,
    componentFilled: FilledIcons.PublicplaceFilledIcon,
  },
  {
    name: 'pump',
    altNames: ['fuel'],
    component: StrokeIcons.PumpIcon,
    componentFilled: FilledIcons.PumpFilledIcon,
  },
  {
    name: 'pump-cng',
    altNames: [],
    component: StrokeIcons.PumpCNGIcon,
    componentFilled: FilledIcons.PumpCNGFilledIcon,
  },
  {
    name: 'pump-lpg',
    altNames: [],
    component: StrokeIcons.PumpLPGIcon,
    componentFilled: FilledIcons.PumpLPGFilledIcon,
  },
  {
    name: 'qr-code',
    altNames: ['qrcode', 'square-qr'],
    component: StrokeIcons.QRCodeIcon,
    componentFilled: FilledIcons.QRCodeFilledIcon,
  },
  {
    name: 'quality',
    altNames: [],
    component: StrokeIcons.QualityIcon,
    componentFilled: FilledIcons.QualityFilledIcon,
  },
  {
    name: 'quality-medal',
    altNames: [],
    component: StrokeIcons.QualityMedalIcon,
    componentFilled: FilledIcons.QualityMedalFilledIcon,
  },
  {
    name: 'radar',
    altNames: ['circle-radar'],
    component: StrokeIcons.RadarIcon,
    componentFilled: FilledIcons.RadarFilledIcon,
  },
  {
    name: 'refresh',
    altNames: ['refresh-clockwise'],
    component: StrokeIcons.RefreshIcon,
    componentFilled: FilledIcons.RefreshFilledIcon,
  },
  {
    name: 'reload',
    altNames: ['arrow-repeat'],
    component: StrokeIcons.ReloadIcon,
    componentFilled: FilledIcons.ReloadFilledIcon,
  },
  {
    name: 'revert',
    altNames: ['refresh-anticlockwise'],
    component: StrokeIcons.RevertIcon,
    componentFilled: FilledIcons.RevertFilledIcon,
  },
  {
    name: 'road-block',
    altNames: ['cone', 'road-assistance'],
    component: StrokeIcons.RoadBlockIcon,
    componentFilled: FilledIcons.RoadBlockFilledIcon,
  },
  {
    name: 'save',
    altNames: [],
    component: StrokeIcons.SaveIcon,
    componentFilled: FilledIcons.SaveFilledIcon,
  },
  {
    name: 'search',
    altNames: [],
    component: StrokeIcons.SearchIcon,
    componentFilled: FilledIcons.SearchFilledIcon,
  },
  {
    name: 'search-minus',
    altNames: [],
    component: StrokeIcons.SearchMinusIcon,
    componentFilled: FilledIcons.SearchMinusFilledIcon,
  },
  {
    name: 'search-plus',
    altNames: [],
    component: StrokeIcons.SearchPlusIcon,
    componentFilled: FilledIcons.SearchPlusFilledIcon,
  },
  {
    name: 'seatheater',
    altNames: [],
    component: StrokeIcons.SeatheaterIcon,
    componentFilled: FilledIcons.SeatheaterFilledIcon,
  },
  {
    name: 'select',
    altNames: ['square-multiple'],
    component: StrokeIcons.SelectIcon,
    componentFilled: FilledIcons.SelectFilledIcon,
  },
  {
    name: 'select-all',
    altNames: ['square-select-multiple'],
    component: StrokeIcons.SelectAllIcon,
    componentFilled: FilledIcons.SelectAllFilledIcon,
  },
  {
    name: 'send',
    altNames: [],
    component: StrokeIcons.SendIcon,
    componentFilled: FilledIcons.SendFilledIcon,
  },
  {
    name: 'settings',
    altNames: [],
    component: StrokeIcons.SettingsIcon,
    componentFilled: FilledIcons.SettingsFilledIcon,
  },
  {
    name: 'shape-circle',
    altNames: ['circle'],
    component: StrokeIcons.ShapeCircleIcon,
    componentFilled: FilledIcons.ShapeCircleFilledIcon,
  },
  {
    name: 'shape-drop',
    altNames: ['drop'],
    component: StrokeIcons.ShapeDropIcon,
    componentFilled: FilledIcons.ShapeDropFilledIcon,
  },
  {
    name: 'shape-rectangle-horizontal',
    altNames: ['rectangle-horizontal', 'rectangle'],
    component: StrokeIcons.ShapeRectangleHorizontalIcon,
    componentFilled: FilledIcons.ShapeRectangleHorizontalFilledIcon,
  },
  {
    name: 'shape-rectangle-rounded',
    altNames: ['rectangle-rounded', 'rounded'],
    component: StrokeIcons.ShapeRectangleRoundedIcon,
    componentFilled: FilledIcons.ShapeRectangleRoundedFilledIcon,
  },
  {
    name: 'shape-rectangle-vertical',
    altNames: ['rectangle-vertical'],
    component: StrokeIcons.ShapeRectangleVerticalIcon,
    componentFilled: FilledIcons.ShapeRectangleVerticalFilledIcon,
  },
  {
    name: 'shape-rhombus',
    altNames: ['rhombus', 'diamond'],
    component: StrokeIcons.ShapeRhombusIcon,
    componentFilled: FilledIcons.ShapeRhombusFilledIcon,
  },
  {
    name: 'shape-shapes',
    altNames: ['shapes', 'square-shapes'],
    component: StrokeIcons.ShapeShapesIcon,
    componentFilled: FilledIcons.ShapeShapesFilledIcon,
  },
  {
    name: 'shape-square',
    altNames: ['square', 'square-image'],
    component: StrokeIcons.ShapeSquareIcon,
    componentFilled: FilledIcons.ShapeSquareFilledIcon,
  },
  {
    name: 'shape-star',
    altNames: ['star'],
    component: StrokeIcons.ShapeStarIcon,
    componentFilled: FilledIcons.ShapeStarFilledIcon,
  },
  {
    name: 'shape-starhalf',
    altNames: ['starhalf'],
    component: StrokeIcons.ShapeStarhalfIcon,
    componentFilled: FilledIcons.ShapeStarhalfFilledIcon,
  },
  {
    name: 'shape-triangle',
    altNames: ['triangle', 'triangle-up'],
    component: StrokeIcons.ShapeTriangleIcon,
    componentFilled: FilledIcons.ShapeTriangleFilledIcon,
  },
  {
    name: 'share',
    altNames: [],
    component: StrokeIcons.ShareIcon,
    componentFilled: FilledIcons.ShareFilledIcon,
  },
  {
    name: 'share-square',
    altNames: [],
    component: StrokeIcons.ShareSquareIcon,
    componentFilled: FilledIcons.ShareSquareFilledIcon,
  },
  {
    name: 'shield-check',
    altNames: ['shield-verified'],
    component: StrokeIcons.ShieldCheckIcon,
    componentFilled: FilledIcons.ShieldCheckFilledIcon,
  },
  {
    name: 'shield-empty',
    altNames: ['shield'],
    component: StrokeIcons.ShieldEmptyIcon,
    componentFilled: FilledIcons.ShieldEmptyFilledIcon,
  },
  {
    name: 'shopping-bag',
    altNames: ['shopping'],
    component: StrokeIcons.ShoppingBagIcon,
    componentFilled: FilledIcons.ShoppingBagFilledIcon,
  },
  {
    name: 'shopping-cart',
    altNames: [],
    component: StrokeIcons.ShoppingCartIcon,
    componentFilled: FilledIcons.ShoppingCartFilledIcon,
  },
  {
    name: 'show',
    altNames: ['preview'],
    component: StrokeIcons.ShowIcon,
    componentFilled: FilledIcons.ShowFilledIcon,
  },
  {
    name: 'shuffle',
    altNames: [],
    component: StrokeIcons.ShuffleIcon,
    componentFilled: FilledIcons.ShuffleFilledIcon,
  },
  {
    name: 'signal',
    altNames: ['radio'],
    component: StrokeIcons.SignalIcon,
    componentFilled: FilledIcons.SignalFilledIcon,
  },
  {
    name: 'sort-down',
    altNames: ['arrow-sort-down'],
    component: StrokeIcons.SortDownIcon,
    componentFilled: FilledIcons.SortDownFilledIcon,
  },
  {
    name: 'sort-up',
    altNames: ['arrow-sort-up'],
    component: StrokeIcons.SortUpIcon,
    componentFilled: FilledIcons.SortUpFilledIcon,
  },
  {
    name: 'soundwave',
    altNames: ['wave'],
    component: StrokeIcons.SoundwaveIcon,
    componentFilled: FilledIcons.SoundwaveFilledIcon,
  },
  {
    name: 'sparkplug',
    altNames: [],
    component: StrokeIcons.SparkplugIcon,
    componentFilled: FilledIcons.SparkplugFilledIcon,
  },
  {
    name: 'sport',
    altNames: [],
    component: StrokeIcons.SportIcon,
    componentFilled: FilledIcons.SportFilledIcon,
  },
  {
    name: 'stats',
    altNames: [],
    component: StrokeIcons.StatsIcon,
    componentFilled: FilledIcons.StatsFilledIcon,
  },
  {
    name: 'steering-wheel',
    altNames: ['steering', 'circle-steering'],
    component: StrokeIcons.SteeringWheelIcon,
    componentFilled: FilledIcons.SteeringWheelFilledIcon,
  },
  {
    name: 'stopwatch',
    altNames: [],
    component: StrokeIcons.StopwatchIcon,
    componentFilled: FilledIcons.StopwatchFilledIcon,
  },
  {
    name: 'subtract',
    altNames: [],
    component: StrokeIcons.SubtractIcon,
    componentFilled: FilledIcons.SubtractFilledIcon,
  },
  {
    name: 'suitcase',
    altNames: [],
    component: StrokeIcons.SuitcaseIcon,
    componentFilled: FilledIcons.SuitcaseFilledIcon,
  },
  {
    name: 'sunroof',
    altNames: [],
    component: StrokeIcons.SunroofIcon,
    componentFilled: FilledIcons.SunroofFilledIcon,
  },
  {
    name: 'task-done',
    altNames: ['task-new'],
    component: StrokeIcons.TaskDoneIcon,
    componentFilled: FilledIcons.TaskDoneFilledIcon,
  },
  {
    name: 'task-none',
    altNames: [],
    component: StrokeIcons.TaskNoneIcon,
    componentFilled: FilledIcons.TaskNoneFilledIcon,
  },
  {
    name: 'task-scheduled',
    altNames: ['schedule', 'tasks'],
    component: StrokeIcons.TaskScheduledIcon,
    componentFilled: FilledIcons.TaskScheduledFilledIcon,
  },
  {
    name: 'technical-info',
    altNames: ['nut', 'parts'],
    component: StrokeIcons.TechnicalInfoIcon,
    componentFilled: FilledIcons.TechnicalInfoFilledIcon,
  },
  {
    name: 'telegram',
    altNames: [],
    component: StrokeIcons.TelegramIcon,
    componentFilled: FilledIcons.TelegramFilledIcon,
  },
  {
    name: 'thumb-down',
    altNames: ['dislike'],
    component: StrokeIcons.ThumbDownIcon,
    componentFilled: FilledIcons.ThumbDownFilledIcon,
  },
  {
    name: 'thumb-up',
    altNames: ['like'],
    component: StrokeIcons.ThumbUpIcon,
    componentFilled: FilledIcons.ThumbUpFilledIcon,
  },
  {
    name: 'ticket',
    altNames: [],
    component: StrokeIcons.TicketIcon,
    componentFilled: FilledIcons.TicketFilledIcon,
  },
  {
    name: 'tiktok',
    altNames: [],
    component: StrokeIcons.TikTokIcon,
    componentFilled: FilledIcons.TikTokFilledIcon,
  },
  {
    name: 'toilets',
    altNames: [],
    component: StrokeIcons.ToiletsIcon,
    componentFilled: FilledIcons.ToiletsFilledIcon,
  },
  {
    name: 'transmission-automatic',
    altNames: [],
    component: StrokeIcons.TransmissionAutomaticIcon,
    componentFilled: FilledIcons.TransmissionAutomaticFilledIcon,
  },
  {
    name: 'transmission-manual',
    altNames: [],
    component: StrokeIcons.TransmissionManualIcon,
    componentFilled: FilledIcons.TransmissionManualFilledIcon,
  },
  {
    name: 'trashcan',
    altNames: ['trash'],
    component: StrokeIcons.TrashcanIcon,
    componentFilled: FilledIcons.TrashcanFilledIcon,
  },
  {
    name: 'trip-cyclic',
    altNames: [],
    component: StrokeIcons.TripCyclicIcon,
    componentFilled: FilledIcons.TripCyclicFilledIcon,
  },
  {
    name: 'trip-long-term',
    altNames: [],
    component: StrokeIcons.TripLongTermIcon,
    componentFilled: FilledIcons.TripLongTermFilledIcon,
  },
  {
    name: 'trip-single',
    altNames: [],
    component: StrokeIcons.TripSingleIcon,
    componentFilled: FilledIcons.TripSingleFilledIcon,
  },
  {
    name: 'trophy',
    altNames: [],
    component: StrokeIcons.TrophyIcon,
    componentFilled: FilledIcons.TrophyFilledIcon,
  },
  {
    name: 'twitter-old',
    altNames: [],
    component: StrokeIcons.TwitterIcon,
    componentFilled: FilledIcons.TwitterFilledIcon,
  },
  {
    name: 'tyre-repair',
    altNames: [],
    component: StrokeIcons.TyreRepairIcon,
    componentFilled: FilledIcons.TyreRepairFilledIcon,
  },
  {
    name: 'tyre-tracks',
    altNames: ['tracks'],
    component: StrokeIcons.TyreTracksIcon,
    componentFilled: FilledIcons.TyreTracksFilledIcon,
  },
  {
    name: 'tyres',
    altNames: ['circle-target'],
    component: StrokeIcons.TyresIcon,
    componentFilled: FilledIcons.TyresFilledIcon,
  },
  {
    name: 'upload',
    altNames: ['arrow-upload'],
    component: StrokeIcons.UploadIcon,
    componentFilled: FilledIcons.UploadFilledIcon,
  },
  {
    name: 'user',
    altNames: ['profile'],
    component: StrokeIcons.UserIcon,
    componentFilled: FilledIcons.UserFilledIcon,
  },
  {
    name: 'ventilation',
    altNames: [],
    component: StrokeIcons.VentilationIcon,
    componentFilled: FilledIcons.VentilationFilledIcon,
  },
  {
    name: 'ventilation-off',
    altNames: [],
    component: StrokeIcons.VentilationOffIcon,
    componentFilled: FilledIcons.VentilationOffFilledIcon,
  },
  {
    name: 'walk',
    altNames: [],
    component: StrokeIcons.WalkIcon,
    componentFilled: FilledIcons.WalkFilledIcon,
  },
  {
    name: 'wallbox',
    altNames: [],
    component: StrokeIcons.WallboxIcon,
    componentFilled: FilledIcons.WallboxFilledIcon,
  },
  {
    name: 'wallet',
    altNames: [],
    component: StrokeIcons.WalletIcon,
    componentFilled: FilledIcons.WalletFilledIcon,
  },
  {
    name: 'wand',
    altNames: [],
    component: StrokeIcons.WandIcon,
    componentFilled: FilledIcons.WandFilledIcon,
  },
  {
    name: 'warning',
    altNames: ['triangle-up-exclamation'],
    component: StrokeIcons.WarningIcon,
    componentFilled: FilledIcons.WarningFilledIcon,
  },
  {
    name: 'weather-rainy',
    altNames: ['weather'],
    component: StrokeIcons.WeatherRainyIcon,
    componentFilled: FilledIcons.WeatherRainyFilledIcon,
  },
  {
    name: 'weather-snow',
    altNames: [],
    component: StrokeIcons.WeatherSnowIcon,
    componentFilled: FilledIcons.WeatherSnowFilledIcon,
  },
  {
    name: 'wellness',
    altNames: [],
    component: StrokeIcons.WellnessIcon,
    componentFilled: FilledIcons.WellnessFilledIcon,
  },
  {
    name: 'whatsapp',
    altNames: [],
    component: StrokeIcons.WhatsAppIcon,
    componentFilled: FilledIcons.WhatsAppFilledIcon,
  },
  {
    name: 'wheelchair',
    altNames: [],
    component: StrokeIcons.WheelchairIcon,
    componentFilled: FilledIcons.WheelchairFilledIcon,
  },
  {
    name: 'wheels',
    altNames: ['tyre', 'circle-tyre'],
    component: StrokeIcons.WheelsIcon,
    componentFilled: FilledIcons.WheelsFilledIcon,
  },
  {
    name: 'wifi-disabled',
    altNames: ['wifi-off'],
    component: StrokeIcons.WifiDisabledIcon,
    componentFilled: FilledIcons.WifiDisabledFilledIcon,
  },
  {
    name: 'wifi-high',
    altNames: ['wifi'],
    component: StrokeIcons.WifiHighIcon,
    componentFilled: FilledIcons.WifiHighFilledIcon,
  },
  {
    name: 'wifi-low',
    altNames: [],
    component: StrokeIcons.WifiLowIcon,
    componentFilled: FilledIcons.WifiLowFilledIcon,
  },
  {
    name: 'wifi-medium',
    altNames: [],
    component: StrokeIcons.WifiMediumIcon,
    componentFilled: FilledIcons.WifiMediumFilledIcon,
  },
  {
    name: 'wifi-no-signal',
    altNames: [],
    component: StrokeIcons.WifiNoSignalIcon,
    componentFilled: FilledIcons.WifiNoSignalFilledIcon,
  },
  {
    name: 'window',
    altNames: ['square-grid-apps'],
    component: StrokeIcons.WindowIcon,
    componentFilled: FilledIcons.WindowFilledIcon,
  },
  {
    name: 'windowheater',
    altNames: [],
    component: StrokeIcons.WindowheaterIcon,
    componentFilled: FilledIcons.WindowheaterFilledIcon,
  },
  {
    name: 'windows-closed',
    altNames: [],
    component: StrokeIcons.WindowsClosedIcon,
    componentFilled: FilledIcons.WindowsClosedFilledIcon,
  },
  {
    name: 'windows-open',
    altNames: [],
    component: StrokeIcons.WindowsOpenIcon,
    componentFilled: FilledIcons.WindowsOpenFilledIcon,
  },
  {
    name: 'windscreen-wiper',
    altNames: ['wiper', 'windshield'],
    component: StrokeIcons.WindscreenWiperIcon,
    componentFilled: FilledIcons.WindscreenWiperFilledIcon,
  },
  {
    name: 'write',
    altNames: ['square-compose'],
    component: StrokeIcons.WriteIcon,
    componentFilled: FilledIcons.WriteFilledIcon,
  },
  {
    name: 'x',
    altNames: ['twitter'],
    component: StrokeIcons.XIcon,
    componentFilled: FilledIcons.XFilledIcon,
  },
  {
    name: 'youtube',
    altNames: [],
    component: StrokeIcons.YouTubeIcon,
    componentFilled: FilledIcons.YouTubeFilledIcon,
  },
];

export const availableIcons = iconDefinitions.flatMap((def) => [def.name, ...def.altNames]);
export type IconNameProp = (typeof availableIcons)[number];
